import { useEffect, useRef } from "preact/hooks";

const skipFrame = (cb: () => void) => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(cb));
};

const useCanvasInit = (
    init: (canvas: HTMLCanvasElement) => (() => void) | void,
    deps: unknown[] = [],
) => {
    const ref = useRef<HTMLCanvasElement | null>(null);

    useEffect(() => {
        const canvas = ref.current;

        if (!canvas) {
            return;
        }

        let cleanup: (() => void) | void;

        const runInit = () => {
            cleanup = init(canvas);
        };

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                skipFrame(runInit);
                document.removeEventListener(
                    "visibilitychange",
                    handleVisibilityChange,
                );
            }
        };

        if (document.hidden) {
            document.addEventListener(
                "visibilitychange",
                handleVisibilityChange,
            );
        } else {
            skipFrame(runInit);
        }

        return () => {
            cleanup?.();
            document.removeEventListener(
                "visibilitychange",
                handleVisibilityChange,
            );
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);

    return ref;
};

export default useCanvasInit;
